module.exports = __webpack_public_path__ + "img/bb-travel-calendar.db05ca8a.svg";